<script>
import Card from "../components/shared/Card.vue";
import { setLiveSession } from "../utils/functions";

export default {
  name: "UpdateLiveView",
  components: { Card },
  methods: {
    setLive() {
      setLiveSession();
    }
  }
};
</script>

<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <Card class="mt-12 p-2 flex justify-center">
      <button class="standard-btn" @click="setLive">Set Live</button>
    </Card>
  </div>
</template>

<style scoped></style>
